import { Link } from 'react-router-dom';
import { useAuth } from '../api.js';
import { Field, inputClass } from './ui.js';

/**
 * Workspace dropdown for the analytics views. Renders nothing unless the account
 * has the multi-workspace feature enabled, so single-workspace accounts never see
 * it. An empty value means "All workspaces" (no scoping). The trailing "+" links
 * to the workspace manager so a new book can be added without leaving the page.
 */
export function WorkspaceFilter({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  const { workspacesEnabled, workspaces } = useAuth();
  if (!workspacesEnabled || workspaces.length === 0) return null;
  return (
    <div className="w-56">
      <Field label="Workspace">
        <div className="flex items-center gap-1.5">
          <select className={inputClass} value={value} onChange={(e) => onChange(e.target.value)}>
            <option value="">All workspaces</option>
            {workspaces.map((w) => (
              <option key={w.id} value={w.id}>
                {w.name}
                {w.isDefault ? ' (default)' : ''}
              </option>
            ))}
          </select>
          <Link
            to="/workspaces"
            title="New workspace"
            aria-label="New workspace"
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-neutral-300 text-neutral-600 transition hover:bg-neutral-100 hover:text-neutral-900 dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-800"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 5v14M5 12h14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </Link>
        </div>
      </Field>
    </div>
  );
}
